import React from 'react';
import {Stack} from '@mui/system';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import {CONTENT_STUDIO_VIEW_NAMES} from '@/lib/analytics/analyticsConstants';
import translate from '@/utils/translate';
import OnboardingFileUploader from '../file-upload/OnboardingFileUploader';

function OnboardingFeatureModal({
  onClickSampleAssets,
}: {
  onClickSampleAssets: () => void;
}) {
  return (
    <Stack direction="column" gap="24px">
      <OnboardingFileUploader
        analyticsLocation={CONTENT_STUDIO_VIEW_NAMES.HOME}
        width="480px"
      />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        border={`1px solid ${designSystemToken('semantic.bg.neutral-inverse')}`}
        borderRadius="16px"
        padding="16px"
        sx={{cursor: 'pointer'}}
        onClick={onClickSampleAssets}
      >
        <Stack direction="row" alignItems="center">
          <Icon
            name="Features-VideoEdit"
            size="medium"
            appearance="neutral"
            style={{marginRight: '8px'}}
          />
          <Body size="lg">{translate('Explore with sample video')}</Body>
        </Stack>
        <Icon
          name="Actions-Arrow-Forward-Small"
          size="medium"
          appearance="neutral"
        />
      </Stack>
    </Stack>
  );
}

export default OnboardingFeatureModal;
